import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { LargeFamilyCardAppEntityLargeFamilyCardWrite } from '../../../../../../openapi';

export class LargeFamilyCardItemForm extends AppForm {
  constructor() {
    super({
      cardNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      street: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      houseNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      apartmentNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.maxLength(255)]
      })
    });
  }

  public toWriteModel(): LargeFamilyCardAppEntityLargeFamilyCardWrite {
    return this.value;
  }
}
